// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f2840123","455":"d267305e"}[chunkId] + ".chunk.js";
};